<template>
  <div class="error-box-bg">
    <div class="error-box">
      <img :src="img" alt="">
      <p>{{ $t('home.loginOut') }}</p>
      <div class="refresh-btn" @click="handleRefresh">{{ $t('home.refresh') }}</div>
    </div>
  </div>
</template>

<script>
import db from '@/utils/localStorage'
import { mapState } from "vuex";
import Dark from '@/assets/imgs/error/loginout-dark.png';
import Light from '@/assets/imgs/error/loginout-light.png';

export default {
  name: 'Empty',
  methods: {
    handleRefresh() {
      db.save('token', 'guestMode')
      this.$store.commit('common/SET_TOKEN', 'guestMode')
      this.$router.replace({ name: 'Schedule' })
    },
  },
  computed: {
    img() {
      return this.theme == 'dark' ? Dark : Light
    },
    theme() {
      return this.common.theme || "light";
    },
    ...mapState(["common", "user"]),
  },
}
</script>

<style lang="scss" scoped>
.error-box-bg {
  display: flex;
  justify-content: center;
  //background: var(--empty-bg);
}

.error-box {
  position: relative;
  width: 170px;
  height: 170px;

  img {
    width: 100%;
  }

  p {
    position: absolute;
    top: 118px;
    left: 0;
    width: 100%;
    font-size: 14px;
    font-weight: 600;
    line-height: normal;
    color: var(--color-4, #999);
    text-align: center;
    margin-top: -70px;
  }

  .refresh-btn {
    margin-top: 16px;
    width: 100%;
    text-align: center;
    font-size: 14px;
    color: #fff;
    background: #F80000;
    border-radius: 20px;
    padding: 8px 0;
    cursor: pointer;

    &:active {
      opacity: 0.8;
    }
  }
}
</style>
